import * as React from 'react';

function SvgArrowLeftInCircle(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.504 18.523a.411.411 0 01-.008.537.317.317 0 01-.483-.01l-3.517-4.054a.412.412 0 010-.529l3.517-4.051a.317.317 0 01.483-.01c.135.147.139.387.008.538l-3.288 3.788 3.288 3.79z"
        fill="#414B56"
      />
      <circle cx={15} cy={15} r={10.5} stroke="#414B56" />
    </svg>
  );
}

export default SvgArrowLeftInCircle;
